// src/pages/BookingConfirmationPage.jsx
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { IoCheckmarkCircle, IoArrowBack } from 'react-icons/io5';

const BookingConfirmationPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { booking } = location.state || {};

  if (!booking) {
    navigate('/');
    return null;
  }

  const getBookingTypeColor = () => {
    switch(booking.bookingType) {
      case 'AIRPORT': return '#1A73E8';
      case 'OUTSTATION': return '#FF6B35';
      case 'LOCAL': return '#0B8A4D';
      default: return '#FFD600';
    }
  };

  const styles = {
    container: {
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      padding: '40px 20px',
      fontFamily: "'Nunito', sans-serif",
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    card: {
      maxWidth: '600px',
      width: '100%',
      background: 'white',
      borderRadius: '20px',
      padding: '40px',
      boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
      textAlign: 'center'
    },
    icon: {
      fontSize: '80px',
      color: '#4CAF50',
      marginBottom: '20px'
    },
    title: {
      fontSize: '32px',
      fontWeight: 800,
      color: '#333',
      marginBottom: '10px'
    },
    subtitle: {
      fontSize: '16px',
      color: '#666',
      marginBottom: '30px'
    },
    bookingId: {
      background: '#f5f5f5',
      padding: '15px',
      borderRadius: '10px',
      marginBottom: '30px'
    },
    idLabel: {
      fontSize: '14px',
      color: '#666',
      marginBottom: '5px'
    },
    idValue: {
      fontSize: '24px',
      fontWeight: 800,
      color: getBookingTypeColor(),
      letterSpacing: '2px'
    },
    details: {
      textAlign: 'left',
      background: '#f8f9fa',
      padding: '20px',
      borderRadius: '10px',
      marginBottom: '30px'
    },
    detailRow: {
      display: 'flex',
      justifyContent: 'space-between',
      padding: '10px 0',
      borderBottom: '1px solid #e0e0e0'
    },
    detailLabel: {
      fontSize: '14px',
      color: '#666',
      fontWeight: 600
    },
    detailValue: {
      fontSize: '14px',
      color: '#333',
      fontWeight: 700
    },
    button: {
      background: getBookingTypeColor(),
      border: 'none',
      padding: '16px 30px',
      borderRadius: '12px',
      fontSize: '16px',
      fontWeight: 700,
      color: 'white',
      cursor: 'pointer',
      transition: 'all 0.2s',
      margin: '10px'
    },
    secondaryButton: {
      background: 'transparent',
      border: '2px solid #ddd',
      padding: '16px 30px',
      borderRadius: '12px',
      fontSize: '16px',
      fontWeight: 700,
      color: '#666',
      cursor: 'pointer',
      transition: 'all 0.2s',
      margin: '10px'
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <IoCheckmarkCircle style={styles.icon} />
        <h1 style={styles.title}>Booking Confirmed!</h1>
        <p style={styles.subtitle}>Your booking has been successfully confirmed</p>

        <div style={styles.bookingId}>
          <div style={styles.idLabel}>Booking ID</div>
          <div style={styles.idValue}>{booking.bookingId || booking.id}</div>
        </div>

        <div style={styles.details}>
          <div style={styles.detailRow}>
            <span style={styles.detailLabel}>Name</span>
            <span style={styles.detailValue}>{booking.name}</span>
          </div>
          <div style={styles.detailRow}>
            <span style={styles.detailLabel}>Mobile</span>
            <span style={styles.detailValue}>{booking.mobile}</span>
          </div>
          <div style={styles.detailRow}>
            <span style={styles.detailLabel}>Email</span>
            <span style={styles.detailValue}>{booking.email}</span>
          </div>
          <div style={styles.detailRow}>
            <span style={styles.detailLabel}>Booking Type</span>
            <span style={styles.detailValue}>{booking.bookingType}</span>
          </div>
          <div style={styles.detailRow}>
            <span style={styles.detailLabel}>Vehicle</span>
            <span style={styles.detailValue}>{booking.vehicle}</span>
          </div>
          <div style={styles.detailRow}>
            <span style={styles.detailLabel}>Pickup Point</span>
            <span style={styles.detailValue}>{booking.pickupPoint}</span>
          </div>
          <div style={styles.detailRow}>
            <span style={styles.detailLabel}>Pickup Date & Time</span>
            <span style={styles.detailValue}>{booking.pickupDate} {booking.pickupTime}</span>
          </div>
          {booking.dropoffPoint && (
            <div style={styles.detailRow}>
              <span style={styles.detailLabel}>Dropoff Point</span>
              <span style={styles.detailValue}>{booking.dropoffPoint}</span>
            </div>
          )}
        </div>

        <div>
          <button 
            style={styles.button}
            onClick={() => navigate('/')}
            onMouseEnter={(e) => e.target.style.transform = 'translateY(-2px)'}
            onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
          >
            BOOK ANOTHER RIDE
          </button>
          <button 
            style={styles.secondaryButton}
            onClick={() => window.print()}
          >
            PRINT RECEIPT
          </button>
        </div>
      </div>
    </div>
  );
};

export default BookingConfirmationPage;